<template>
  <div>
    <iframe 
        frameborder="0" 
        height="770" 
        scrolling="no" 
        src="http://192.168.0.23/views/AndonCF/LiveAndonList?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&&:toolbar=false&:display_count=no&:showVizHome=no" 
        width="1100"></iframe>
  </div>
</template>
<script>

import server from '../../api/server.vue'

export default {
  name: 'AndonNotReceived',
  props: [],
  data() {
    return {
      list: []
    };
  },
  methods: {
  },
  mounted: function () {
  }
};
</script>

<style type="text/css">
</style>


// WEBPACK FOOTER //
// src/components/andon/andon_not_received.vue